export default __webpack_public_path__ + "static/media/zertiassist_iconos_points_24px.bdb8cc6b.svg";